import {
  Button,
  Checkbox,
  Grid,
  MenuItem,
  Popover,
  Select
} from "@material-ui/core";
import { Box, Typography } from "@mui/material";
import {
  ArrowLeft,
  Checks,
  CheckSquareOffset,
  CircleHalf,
  ClockCounterClockwise,
  PaintBrushHousehold,
  Plus,
  X,
} from "phosphor-react";
import { useEffect, useState } from "react";
import { fget, fpatch, fpost } from "../../../API/callsAPI";
import commonStyles from "../../../Utils/commonStyles";
import Loader from "../../Utilities/Loader/Loader";
import StatusViewer from "../../Utilities/StatusViewer/StatusViewer";
import addShotToSequencerTimelineModalStyles from "./addShotToSequencerTimelineModalStyles";

const AddShotToSequencerTimelineModal = ({
  sequencesInTimeline,
  projectId,
  playListId,
  currentShotsInTimeline,
  closeModal,
  resetAllBatches,
  addBetweenShots,
  setAddBetweenShots,
}) => {
  const classes = addShotToSequencerTimelineModalStyles();
  const commonClasses = commonStyles();
  const [currentView, setCurrentView] = useState("sequences");
  const [selectedSequence, setSelectedSequence] = useState({});
  const [shotsList, setShotsList] = useState([]);
  const [isShotsLoading, setIsShotsLoading] = useState(true);
  const [shotStatusList, setShotStatusList] = useState([]);
  const [selectedStatusForShot, setSelectedStatusForShot] = useState([]);

  //sequences
  const [sequencesList, setSequencesList] = useState([]);
  const [isSequencesLoading, setIsSequencesLoading] = useState(true);

  // select shot version
  const [selectedShot, setSelectedShot] = useState({});
  const [shotVersions, setShotVersions] = useState([]);
  const [isShotVersionsLoading, setIsShotVersionsLoading] = useState(true);

  const [selectedShots, setSelectedShots] = useState([]);

  const handleSelectUnselectShot = (shot) => {
    const isExist = selectedShots?.some((sin) => shot.id === sin.id);
    if (isExist) {
      const others = selectedShots.filter((sin) => sin.id !== shot.id);
      setSelectedShots(others);
    } else {
      setSelectedShots((selectedShots) => [...selectedShots, shot]);
    }
  };

  // multi select popover
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  //multi select from
  const [multiSelectFrom, setMultiSelectFrom] = useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
    setMultiSelectFrom("");
  };

  useEffect(() => {
    if (anchorEl) {
      setOpen(true);
    }
  }, [anchorEl]);

  async function fetchSequences() {
    setIsSequencesLoading(true);
    const url = `trackables/shot-sequence/?page=1&project=${projectId}`;
    try {
      const res = await fget({
        url: url,
      });
      setSequencesList(res?.data);
      setIsSequencesLoading(false);
    } catch (error) {
      console.log("error", error);
      setIsSequencesLoading(false);
    }
  }

  useEffect(() => {
    if (currentView === "sequences") {
      fetchSequences();
    }
  }, [currentView, projectId]);

  async function fetchShots() {
    setIsShotsLoading(true);
    const statusQuery = selectedStatusForShot
      ?.map((statusId) => `status=${statusId}`)
      .join("&");

    const url = `trackables/shot/?page=1&project=${projectId}&parent_sequence=${selectedSequence?.id}${statusQuery ? `&${statusQuery}` : ""
      }`;
    try {
      const res = await fget({
        url: url,
      });
      setShotsList(res?.data);
      setIsShotsLoading(false);
      console.log(res);
    } catch (error) {
      console.log("error", error);
      setIsShotsLoading(false);
    }
  }

  async function fetchShots() {
    setIsShotsLoading(true);
    const statusQuery = selectedStatusForShot
      ?.map((statusId) => `status=${statusId}`)
      .join("&");

    const url = `trackables/shot/?page=1&project=${projectId}&parent_sequence=${selectedSequence?.id}${statusQuery ? `&${statusQuery}` : ""
      }`;
    try {
      const res = await fget({
        url: url,
      });
      setShotsList(res?.data);
      setIsShotsLoading(false);
      console.log(res);
    } catch (error) {
      console.log("error", error);
      setIsShotsLoading(false);
    }
  }
  async function fetchShotsStatusList() {
    // setIsShotsLoading(true);
    const url = `/trackables/status-list/${14}/?project=${projectId}`;
    try {
      const res = await fget({
        url: url,
      });
      setShotStatusList(res?.data?.results || []);
      //   setIsShotsLoading(false);
      console.log(res);
    } catch (error) {
      console.log("error", error);
      //   setIsShotsLoading(false);
    }
  }
  useEffect(() => {
    if (selectedSequence && currentView === "shot") {
      fetchShots();
    }
  }, [currentView, selectedSequence, selectedStatusForShot]);

  useEffect(() => {
    if (currentView === "shot") {
      fetchShotsStatusList();
    }
  }, [currentView]);

  async function fetchFilteredShotVersion() {
    setIsShotVersionsLoading(true);
    const url = `trackables/shot-version/?page=${1}&shot=${selectedShot?.id}`;
    try {
      const res = await fget({
        url: url,
      });

      setShotVersions(res.data);
      setIsShotVersionsLoading(false);
    } catch (error) {
      console.log(error);
      setIsShotVersionsLoading(false);
    }
  }

  useEffect(() => {
    if (selectedShot && currentView === "shot-version") {
      fetchFilteredShotVersion();
    }
  }, [currentView, selectedSequence]);

  const handlePlaylistEdit = async () => {
    try {
      const prevIds = sequencesInTimeline?.map((sin) => sin.id);
      const res = await fpatch({
        url: `sequencers/timelines/${playListId}/`,
        data: {
          sequences: [...prevIds, selectedSequence?.id],
        },
      });
      if (res.status === 200) {
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [currentStartTime, setCurrentStartTime] = useState(0);
  const handleAddShotToTimeline = async () => {
    const layersRes = await fget({
      url: `sequencers/layers/?timeline=${playListId}`,
    });

    const newLayersData = {};
    if (!layersRes?.data?.results?.length) {
      const newRes = await fpost({
        url: "sequencers/layers/",
        data: {
          name: `Layer ${layersRes?.data?.results?.length + 1}`,
          timeline: playListId,
        },
      });
      newLayersData.id = newRes?.data?.id;
    }
    const isSequenceAlreadyInTimeline = sequencesInTimeline?.some(
      (sin) => sin.id === selectedSequence?.id,
    );
    if (!isSequenceAlreadyInTimeline) {
      handlePlaylistEdit();
    }
    let data = [];
    for (let index = 0; index < selectedShots.length; index++) {
      const element = selectedShots[index];
      const url = `trackables/shot-version/?page=${1}&shot=${element?.id}`;
      try {
        const res = await fget({
          url: url,
        });
        const latestVersion =
          res?.data?.results[res?.data?.results?.length - 1];

        if (latestVersion?.fps && latestVersion?.duration) {
          const endTime = latestVersion?.fps * latestVersion?.duration;
          const shotsRepData = {
            url: "sequencers/shot-reprs/",
            data: {
              start_frame: currentStartTime,
              end_frame: currentStartTime + Math.ceil(endTime),
              visibility_status: true,
              layer: layersRes?.data?.results[0]?.id ?? newLayersData?.id,
              shot: element?.id,
              shot_version: latestVersion?.id,
            },
          };
          const res = await fpost(shotsRepData);
          if (res.status === 201 || res.status === 200) {
            data.push(res?.data?.id);
          }
          setCurrentStartTime(Math.ceil(endTime) + 1);
        }
      } catch (error) {
        console.log(error);
      }
    }
    if (addBetweenShots?.length) {
      const newOrder = [addBetweenShots[0], ...data, addBetweenShots[1]];
      const res = await fpost({
        url: `sequencers/timelines/${playListId}/rearrange/`,
        data: {
          new_order: newOrder,
        },
      });
      setAddBetweenShots([]);
    }
    resetAllBatches();
    closeModal();
  };

  return (
    <div className={classes.modalRoot}>
      <Box className={commonClasses.flexBetween}>
        <Typography>Add shots to timeline</Typography>
        <Button onClick={closeModal}>
          <X />
        </Button>
      </Box>
      <Box className={commonClasses?.flexBetween}>
        <Box className={classes.breadCrumb}>
          <Typography
            style={{
              color: selectedSequence?.id ? "#B1B5C9" : "",
              cursor: "pointer",
            }}
            onClick={() => {
              setCurrentView("sequences");
              setSelectedSequence(null);
              setSelectedShot(null);
            }}
          >
            Sequences
          </Typography>
          {selectedSequence?.code && (
            <Typography
              style={{
                color: selectedShot?.id ? "#B1B5C9" : "",
                cursor: "pointer",
              }}
              onClick={() => {
                setCurrentView("shot");
                setSelectedShot(null);
              }}
            >
              {`>`}
              {"  "}
              {selectedSequence?.code}
            </Typography>
          )}
          {selectedShot?.code && (
            <Typography>
              {`>`}
              {"  "}
              {selectedShot?.code}
            </Typography>
          )}
        </Box>
        <Box className={classes.searchAndSortOptions}>
          <Button
            startIcon={<Checks />}
            className={classes.multiSelectButton}
            onClick={handleClick}
          >
            Multi Select
          </Button>
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            PaperProps={{
              style: {
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none",
              },
            }}
          >
            {multiSelectFrom === "status" ? (
              <Box className={classes.popoverCard}>
                <Button
                  startIcon={<ArrowLeft size={16} />}
                  className={classes.backButton}
                  onClick={() => setMultiSelectFrom("")}
                >
                  Back
                </Button>
                <Box className={classes.choosePart}>
                  <Typography className={classes.chooseLabel}>
                    Choose Status
                  </Typography>
                  <Box className={classes.selectStatusDropdownContainer}>
                    <Select
                      style={{ width: "100%" }}
                      labelId="demo-simple-select-outlined-label"
                      id="selectStatusA"
                      disableUnderline={true}
                      value=""
                      // onChange={formik.handleChange}
                      className={classes.dropdownSelect}
                      name="status"
                      label="Select Status"
                    >
                      <MenuItem value="" disabled>
                        Select Status
                      </MenuItem>
                      {[
                        {
                          id: "1",
                          color: "255, 235, 59",
                          name: "status",
                          code: "1234",
                        },
                      ]?.map((eachStatus) => (
                        <MenuItem value={eachStatus.id} key={eachStatus.id}>
                          <span
                            style={{
                              height: "15px",
                              width: "15px",
                              backgroundColor: `rgb(${eachStatus?.color})`,
                              borderRadius: "50%",
                              display: "inline-block",
                              margin: "0px 5px",
                            }}
                          ></span>
                          {eachStatus.name} - {eachStatus.code}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Box>
                <Box
                  sx={{
                    padding: "8px",
                  }}
                >
                  <Button className={classes.applyChangesButton} disabled>
                    Apply Changes
                  </Button>
                </Box>
              </Box>
            ) : (
              <Box className={classes.popoverCard}>
                <Box className={classes.singlePopoverItem}>
                  <Box className={classes.popoverItemTitle}>
                    <ClockCounterClockwise />
                    <Typography className={classes.popoverItemTitleText}>
                      From Latest
                    </Typography>
                  </Box>
                  <Typography className={classes.popoverItemHelperText}>
                    Selects all the latest shot versions
                  </Typography>
                </Box>
                <Box
                  className={classes.singlePopoverItem}
                  onClick={() => setMultiSelectFrom("status")}
                >
                  <Box className={classes.popoverItemTitle}>
                    <CircleHalf />
                    <Typography className={classes.popoverItemTitleText}>
                      From Status
                    </Typography>
                  </Box>
                  <Typography className={classes.popoverItemHelperText}>
                    Selects all latest shot versions from a specific status
                  </Typography>
                </Box>
                <Box className={classes.singlePopoverItem}>
                  <Box className={classes.popoverItemTitle}>
                    <CheckSquareOffset />
                    <Typography className={classes.popoverItemTitleText}>
                      From Task
                    </Typography>
                  </Box>
                  <Typography className={classes.popoverItemHelperText}>
                    Selects all latest shot versions from a specific task
                  </Typography>
                </Box>
              </Box>
            )}
          </Popover>
          {currentView === "shot" && (
            <div style={{ width: "150px" }}>
              <Select
                multiple
                value={selectedStatusForShot}
                onChange={(e) => setSelectedStatusForShot(e.target.value)}
                disableUnderline
                className={classes.datePickerComponent}
                renderValue={(selected) =>
                  selected
                    .map(
                      (id) =>
                        shotStatusList.find((status) => status.id === id)?.name,
                    )
                    .join(", ")
                }
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>

                {shotStatusList?.map((taskStatus) => (
                  <MenuItem key={taskStatus.id} value={taskStatus.id}>
                    <Checkbox
                      checked={
                        selectedStatusForShot.indexOf(taskStatus.id) > -1
                      }
                    />
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span
                        style={{
                          backgroundColor: `rgb(${taskStatus?.color})`,
                          borderRadius: "50%",
                          display: "inline-block",
                          marginRight: "10px",
                          height: "15px",
                          width: "15px",
                        }}
                      />
                      {taskStatus.name}
                    </div>
                  </MenuItem>
                ))}
              </Select>
            </div>
          )}
          {/* <SortButton /> */}
          {/* <TextField /> */}
        </Box>
      </Box>
      {currentView === "sequences" ? (
        <>
          {!isSequencesLoading ? (
            <Grid container spacing={2}>
              {sequencesList?.results?.map((sin) => (
                <Grid item sm={6} md={2} key={sin?.id}>
                  <Box
                    className={classes.singleSequenceCard}
                    onClick={() => {
                      setCurrentView("shot");
                      setSelectedSequence(sin);
                    }}
                  >
                    <img
                      src={
                        sin?.thumbnail ??
                        "https://i.ibb.co.com/8n8Cp0tC/image.png"
                      }
                      alt=""
                      style={{
                        height: "100px",
                        width: "100%",
                      }}
                    />
                    <Typography className={classes.shotName}>
                      {sin?.code}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Box>
              <Loader />
            </Box>
          )}
        </>
      ) : currentView === "shot" ? (
        <>
          {!isShotsLoading ? (
            <Grid container spacing={2} className={classes.shotsContainer}>
              {shotsList?.results?.map((sin) => (
                <Grid item sm={6} md={2} key={sin.id}>
                  <Box className={classes.singleSequenceCard}>
                    <img
                      src={
                        sin?.latest_thumbnail ??
                        "https://i.ibb.co.com/8n8Cp0tC/image.png"
                      }
                      alt=""
                      style={{
                        height: "100px",
                        width: "100%",
                      }}
                    />
                    <Box className={classes.selectionContainer}>
                      <Checkbox
                        checked={
                          selectedShots?.some((shot) => shot.id === sin.id) ||
                          currentShotsInTimeline?.some(
                            (shot) => shot?.shot === sin?.id,
                          )
                        }
                        style={{
                          padding: "0px",
                          minWidth: "0px",
                        }}
                        onClick={() => {
                          // setCurrentView("shot-version");
                          handleSelectUnselectShot(sin);
                          // setSelectedShot(sin);
                        }}
                        disabled={currentShotsInTimeline?.some(
                          (shot) => shot?.shot === sin?.id,
                        )}
                      />
                      <Typography className={classes.shotName}>
                        {sin?.code?.slice(0, 16)}
                      </Typography>
                    </Box>
                    <Box className={commonClasses.flexBetween}>
                      <StatusViewer status={sin?.status} />
                      <Typography className={classes.inTimelineIndicator}>
                        {currentShotsInTimeline?.some(
                          (shot) => shot?.shot === sin?.id,
                        )
                          ? "In Timeline"
                          : ""}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Box>
              <Loader />
            </Box>
          )}
        </>
      ) : (
        <>
          {!isShotVersionsLoading ? (
            <Grid
              container
              spacing={2}
              sx={{ height: "600px", overflowY: "auto" }}
            >
              {shotVersions?.results?.map((sin) => (
                <Grid item sm={6} md={2} key={sin.id}>
                  <Box
                    className={classes.singleSequenceCard}
                    onClick={() => {
                      setCurrentView("shot");
                      setSelectedSequence(sin);
                    }}
                  >
                    <img
                      src={
                        sin?.thumbnail ??
                        "https://i.ibb.co.com/8n8Cp0tC/image.png"
                      }
                      alt=""
                      style={{
                        height: "100px",
                        width: "100%",
                      }}
                    />
                    <Typography>{sin?.name}</Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Box>
              <Loader />
            </Box>
          )}
        </>
      )}
      <Box
        sx={{
          position: "absolute",
          bottom: "10px",
          width: "97%",
          padding: "10px",
          backgroundColor: "#252A38",
          borderRadius: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography>{selectedShots?.length} Selected</Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
          }}
        >
          <Button
            onClick={() => setSelectedShots([])}
            style={{
              border: "1px solid #6C65D9",
              padding: "4px 8px",
              borderRadius: "5px",
            }}
            startIcon={<PaintBrushHousehold />}
          >
            Clear Selection
          </Button>
          <Button
            onClick={handleAddShotToTimeline}
            disabled={!selectedShots?.length}
            style={{
              backgroundColor: "#6C65D9",
              padding: "4px 8px",
              borderRadius: "5px",
            }}
            startIcon={<Plus />}
          >
            Add To Timeline
          </Button>
        </Box>
      </Box>
    </div>
  );
};

export default AddShotToSequencerTimelineModal;
